module.exports = __webpack_public_path__ + "2796f85931f17b3846ac5b80e8430884.gif";